const addresses = {
    rinkeby: '0x241859f2cEdC45Bd36b19bB9911f921Efe00F807',
    mainnet: '0x9cE7C123d532237ee8B2A01eA9c76732a6444e55'
}

export default addresses;